/*
 * @Descripttion:
 * @Author: 李子和
 * @Date: 2019-12-05 09:35:12
 */
export default {
  namespaced: true,
  state: {
    matchResult: {
      groupList: [], // 比赛分组数据
      awardList: [] // 比赛获奖数据
    },
    numberOfMatch: 1 // 比赛名次
  },
  getters: {
    getMatchResult (state) {
      return state.matchResult
    },
    getNumberOfMatch (state) {
      return state.numberOfMatch
    }
  },
  mutations: {
    changeMatchResult (state, data) {
      state.matchResult = data
    },
    changeNumberOfMatch (state, data) {
      state.numberOfMatch = data
    }
  },
  actions: {
    commitChangeMatchResult ({ commit }, data) {
      commit('changeMatchResult', data)
    },
    commitChangeNumberOfMatch ({ commit }, data) {
      commit('changeNumberOfMatch', data)
    }
  }
}



// WEBPACK FOOTER //
// ./src/store/modules/match.js